import { msg } from '@lingui/macro';
import type { MessageDescriptor } from '@lingui/core';

export type EnvironmentType = 'DEV' | 'TEST' | 'PROD';

/**
 * Get Ant Design tag color for environment type
 */
export const getEnvironmentColor = (env?: string): string => {
  switch (env) {
    case 'PROD':
      return 'red';
    case 'TEST':
      return 'orange';
    case 'DEV':
      return 'blue';
    default:
      return 'default';
  }
};

/**
 * Get translated label for environment type
 * Note: The MessageDescriptor must be used with useLingui's _ function to get the translated string
 */
export const getEnvironmentLabel = (env?: string): MessageDescriptor => {
  switch (env) {
    case 'PROD':
      return msg`Prod`;
    case 'TEST':
      return msg`Test`;
    case 'DEV':
      return msg`Dev`;
    default:
      return msg`Unknown`;
  }
};
